var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeCancellation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "free-cancellation_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.392157 0 0 0 0 0.478431 0 0 0 0 0.592157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#free-cancellation_svg__a)",
    transform: "translate(-174 -618)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#647A97",
    transform: "translate(174 618)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.333,
    cy: 2.417,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.333,
    cy: 4.25,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.733 6.351a.166.166 0 00.209.082c.32-.12.652-.21.99-.266a.085.085 0 00.07-.084.666.666 0 10-1.333 0 .622.622 0 00.064.268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.667.25H1.333C.597.25 0 .847 0 1.583v1.854a1 1 0 00.875.993 1.667 1.667 0 010 3.307A1 1 0 000 8.729v1.854c0 .737.597 1.334 1.333 1.334h4.845c.046 0 .09-.02.122-.053a.174.174 0 00.045-.125 4.29 4.29 0 01-.012-.322c.001-.216.016-.432.045-.646a.167.167 0 00-.165-.188H1.5a.166.166 0 01-.167-.166V9.139c0-.075.05-.141.123-.161a3 3 0 000-5.789.167.167 0 01-.123-.161V1.75c0-.092.075-.167.167-.167h13c.092 0 .167.075.167.167v1.278a.164.164 0 01-.124.16 2.978 2.978 0 00-2.2 2.76.166.166 0 00.145.177c.328.041.65.114.965.216.052.017.11.006.153-.028a.163.163 0 00.064-.142v-.088c0-.84.625-1.548 1.458-1.653A1 1 0 0016 3.437V1.583C16 .847 15.403.25 14.667.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M11.667 7.083A4.333 4.333 0 1016 11.417a4.34 4.34 0 00-4.333-4.334zm1.666 4.834H10a.5.5 0 010-1h3.333a.5.5 0 010 1z"
  })))));
}
export default SvgFreeCancellation;